import React from 'react'
import { Modal, Button } from 'antd'
import { connect } from 'react-redux'
import classNames from 'classnames'
import ButtonPurple from 'components/design/Form/ButtonPurple'
import customLanguageTexts from '../../../language'
import constants from '../../../constants'
import './index.css'

const mapStateToProps = ({ settings: { visibleModalID }, apps }) => ({ visibleModalID, apps })
@connect(mapStateToProps)
class ModalIntentRequest extends React.Component {
  handleCancel = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'apps/HIDE_INTENT_REQUEST',
    })
  }

  handleRecordIntent = (requestParam = '') => {
    const { dispatch, apps } = this.props
    if (
      apps.currentIntentRequest === constants.ManualOutreachIntents['app-migration-request-to-v3']
    ) {
      dispatch({
        type: 'apps/APP_MIGRATION_REQUEST_MANUAL_INTENT',
      })
    } else if (
      apps.currentIntentRequest ===
      constants.ManualOutreachIntents['restore-app-scheduled-for-deletion-request']
    ) {
      dispatch({
        type: 'apps/RESTORE_DELETED_APP_REQUEST',
      })
    } else if (
      apps.currentIntentRequest === constants.ManualOutreachIntents['import-users-request']
    ) {
      dispatch({
        type: 'apps/IMPORT_USERS_REQUEST_MANUAL_INTENT',
        payload: { importFrom: requestParam },
      })
    }
  }

  render() {
    const { visibleModalID, apps } = this.props
    const modalID = 'intentRequest'
    const visible = modalID === visibleModalID
    let intentName = ''
    let intentMessage = ''
    let intentType = 'regular'

    if (
      apps.currentIntentRequest === constants.ManualOutreachIntents['app-migration-request-to-v3']
    ) {
      intentName = 'Request App Migration'
      intentMessage = customLanguageTexts.MIGRATE_APP_REQUEST_MSG
    } else if (
      apps.currentIntentRequest ===
      constants.ManualOutreachIntents['restore-app-scheduled-for-deletion-request']
    ) {
      intentName = 'Restore app'
      intentMessage = customLanguageTexts.RESTORE_APP_REQUEST_MSG
    } else if (
      apps.currentIntentRequest === constants.ManualOutreachIntents['import-users-request']
    ) {
      intentName = 'Import users'
      intentMessage = customLanguageTexts.IMPORT_USERS_REQUEST_MSG
      intentType = apps.currentIntentRequest
    }

    return (
      <Modal
        className={classNames('custom_intent_modal', 'intent__modal')}
        title={<div>{intentName}</div>}
        open={visible}
        onCancel={this.handleCancel}
        footer={
          <div
            style={{
              display: 'inline-flex',
              columnGap: '10px',
            }}
          >
            {intentType === 'regular' && (
              <React.Fragment>
                <ButtonPurple
                  buttonText="Yes"
                  type="primary"
                  className="width-150 mb-3"
                  onClick={this.handleRecordIntent}
                />

                {/* <ButtonGrey
                  buttonText="Cancel"
                  type="default"
                  className="width-150"
                  onClick={this.handleCancel}
                  buttonStyles={{ height: '38px' }}
                /> */}
              </React.Fragment>
            )}
            {intentType === 'import-users-request' && (
              <React.Fragment>
                <Button
                  type="primary"
                  className="width-200 mb-3"
                  onClick={() => this.handleRecordIntent('database')}
                >
                  A database
                </Button>
                <Button
                  type="primary"
                  className="width-200 mb-3"
                  onClick={() => this.handleRecordIntent('csv-file')}
                >
                  A CSV file
                </Button>
                <Button
                  type="primary"
                  className="width-200 mb-3"
                  onClick={() => this.handleRecordIntent('another-chat-provider')}
                >
                  Another chat provider
                </Button>
              </React.Fragment>
            )}
          </div>
        }
      >
        <div className="p-0">
          {/* <p className="com__congrats__heading">
            <strong className="mr-4">{intentName}</strong>
          </p> */}
          <div className="">
            {/* {intentType === 'regular' && (
              <span className="mr-2" role="img" aria-label=":)">
                👋
              </span>
            )} */}

            {intentMessage}
          </div>
        </div>
      </Modal>
    )
  }
}

export default ModalIntentRequest
